<template>
  <v-menu>
    <template v-slot:activator="{ on }">
      <v-btn v-if="mode !== 'ebook'" v-on="on" icon>
        <img alt="tcdc" class="tcdc-share-icon" src="../../assets/icons/generals/share.png"/>
      </v-btn>
      <div v-else v-on="on" v-ripple class="pa-2" style="border-radius: 30px; width: 250px;">
        <div class="d-flex align-center">
          <img alt="tcdc" class="tcdc-share-icon mr-4" src="../../assets/icons/generals/share.png"/>
          <span class="text-tcdc-green bold" style="white-space: nowrap">Share this E-Book</span>
        </div>
      </div>
    </template>
    <v-list dense>
        <v-list-item
            v-ripple
            @click="shareTo('Facebook')"
        >
          <img
              alt="tcdc"
              :src="require('../../assets/icons/social/facebook.png')"
              class="mr-2"
              style="border-radius: 100%"
              width="30px"
          >
          Facebook
        </v-list-item>
      <ShareNetwork
          network="twitter"
          :url="urlTwitterShare"
          :title="title"
          :description="description"
      >
        <v-list-item
            v-ripple
        >
          <img
              alt="tcdc"
              :src="require('../../assets/icons/social/twitter.png')"
              class="mr-2"
              style="border-radius: 100%"
              width="30px"
          >
          X
        </v-list-item>
      </ShareNetwork>
    </v-list>
  </v-menu>
</template>

<script>
import {domain_web} from "../../util/Constants";
import {mapState} from "vuex";

export default {
  name: "ShareButton",
  props: {
    mode: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    }
  },
  data: () => ({
    http: domain_web
  }),
  computed: {
    ...mapState({
      lang: state => state.Branch.lang
    }),
    urlTwitterShare: function () {
      switch (this.mode) {
        case 'article':
        case 'e-book':
          return this.http + '/twitter-share/' + this.mode + '/' + this.$route.params.slug_id

        case 'online-exhibition':
          return `${this.http}/share/online-ex/${this.$route.params.id}`

        case 'program':
          return `${this.http}/share/product/${this.$route.params.id}`

        case 'news':
          return `${this.http}/share/news/${this.$route.params.id}`

        case 'world-calendar':
          return `${this.http}/share/world-calendar/${this.$route.params.id}`

        default:
          return `${window.location}`
      }
    }
  },
  methods: {
    shareTo(social) {
      let fb = 'https://www.facebook.com/sharer/sharer.php?u=';
      switch (social) {
        case "Facebook":
          // console.log(fb + window.location.href)
          // facebook shares
          window.open(`${fb + window.location.href}`);
          // switch (this.mode) {
          //   case 'online-exhibition':
          //     console.log("case online-exhibition")
          //     // console.log(fb + window.location.href)
          //     window.open(`${this.http}/share/online-ex/${this.$route.params.id}?lang=${this.lang}`);
          //     break;
          //   case 'program':
          //     console.log("case program")
          //     // console.log(fb + window.location.href)
          //     window.open(`${this.http}/share/product/${this.$route.params.id}?lang=${this.lang}`);
          //     break;
          //   case 'news':
          //     console.log("case news")
          //     // console.log(fb + window.location.href)
          //     window.open(`${this.http}/share/news/${this.$route.params.id}?lang=${this.lang}`);
          //     break;
          //   case 'world-calendar':
          //     console.log("case world-calendar")
          //     // console.log(fb + window.location.href)
          //     window.open(`${this.http}/share/world-calendar/${this.$route.params.id}?lang=${this.lang}`);
          //     break;
          //   case 'article':
          //     console.log("case article")
          //     // console.log(fb + window.location.href)
          //     window.open(`${this.http}/share/article/${this.$route.params.id}?lang=${this.lang}`);
          //     break;
          //   case 'ebook':
          //     console.log("case ebook")
          //     // console.log(fb + window.location.href)
          //     window.open(`${this.http}/share/ebook/${this.$route.params.id}?lang=${this.lang}`);
          //     break;
          // }
          break;

        // case "Twitter":
        //   // twitter shares
        //   window.open(`https://twitter.com/intent/tweet?url=${window.location}`);
        //   break;

      }
    }
  }
}
</script>

<style scoped>

</style>
